// extracted by mini-css-extract-plugin
export var connectwithus = "cwu-module--connectwithus--6JyaL";
export var connecticons = "cwu-module--connecticons--jNfDp";
export var eachicon = "cwu-module--eachicon---kYi0";
export var images = "cwu-module--images--XXSeG";
export var header = "cwu-module--header--Pun4i";
export var copyright = "cwu-module--copyright--ksv2j";
export var column = "cwu-module--column--7ni+w";